module.exports = __webpack_public_path__ + "img/cz-shopmall.9d3e3a94.svg";